import { orchestrator } from 'satcheljs';
import {
    updateSelectedOption,
    updateTextFieldValue,
    updateNavIndex,
    onOptionSelected,
} from '../actions/selectedOptionActions';

orchestrator(onOptionSelected, ({ viewState, formatFunction, selectedOption }) => {
    if (selectedOption) {
        updateSelectedOption(viewState, selectedOption);
        updateTextFieldValue(viewState, formatFunction(selectedOption));
        updateNavIndex(viewState, selectedOption.index);
    } else {
        updateSelectedOption(viewState, null);
        updateTextFieldValue(viewState, '');
        updateNavIndex(viewState, -1);
    }
});
